// extracted by mini-css-extract-plugin
export default {"form":"CustomerAlertConfigDialog_form__ZXAef"};